export default __webpack_public_path__ + "static/media/MQ.e3b46acd.svg";